import {SbBlokData} from "@storyblok/react";

import {IFeatureItem} from "../../types/IFeatureItem";
import Head from "next/head";
import {transformImage} from "../../utils/StoryblokService";
import React from "react";
import {Disclosure} from "@headlessui/react";
import {ArrowRightIcon} from "@heroicons/react/20/solid";
import classNames from "classnames";

type FAQItem = {
    question: string,
    answer: string
}

type TProps = {
    blok: {
        items: FAQItem[],
        render: boolean,
        title: string,
        subtitle: string
    } & SbBlokData
}

export default function FAQData(props: TProps) {
    const {blok} = props;
    return <>
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(
                        {
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": blok.items.map((item, index) => {
                                return {
                                    "@type": "Question",
                                    "name": item.question,
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": item.answer
                                    }
                                }
                            })
                        }
                    )
                }}/>

        </Head>

        <div className="bg-white padding-normal">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                        {blok.title}
                    </h2>
                    <p className="mt-2 text-lg leading-8 text-gray-600">
                        {blok.subtitle}
                    </p>
                </div>
                <div className={'py-12'}>

                    {blok.items.map((item, index) => {
                        return <div className={'py-4'} key={index}>
                            <Disclosure>
                                {({open}) => (
                                    <>
                                        <Disclosure.Button
                                            className={classNames(
                                                "relative w-full ring-1 cursor-pointer flex hover:ring-amber-300 hover:z-20 justify-space-between items-center gap-4 group p-4 bg-gray-100 ring-transparent",
                                                "rounded-t-xl",
                                                open ? "rounded-b-none" : "rounded-b-xl"
                                            )}
                                        >
                                            {item.question}

                                            <div
                                                className="pointer-events-none ml-auto text-gray-300 group-hover:text-gray-400"
                                                aria-hidden="true"
                                            >
                                                <ArrowRightIcon
                                                    className={classNames('w-6 h-6', open ? 'rotate-90 transform' : '')}/>
                                            </div>
                                        </Disclosure.Button>

                                        <Disclosure.Panel className="text-gray-500 bg-gray-50 p-4">
                                            {item.answer}
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                        </div>
                    })}

                </div>
            </div>
        </div>


    </>
}

